import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getProviderClientDetailsModel } from "../slice/provider-clientDetailsModel";

const ProviderClientDetailsModal = ({ client: clientId, onClose }) => {
  const dispatch = useDispatch();
  const { providerClientDetailsModelData } = useSelector(
    (state) => state.providerClientDetailsModel
  );

  useEffect(() => {
    if (clientId) {
      dispatch(getProviderClientDetailsModel(clientId));
    }
  }, [dispatch, clientId]);

  if (!providerClientDetailsModelData || providerClientDetailsModelData.id !== clientId) {
    return (
      <div className="modal show d-block" style={{ backgroundColor: "rgba(0,0,0,0.5)" }}>
        <div className="modal-dialog">
          <div className="modal-content text-center p-5">
            <div className="spinner-border text-primary" role="status" />
            <p className="mt-3">Loading client details...</p>
          </div>
        </div>
      </div>
    );
  }

  const client = providerClientDetailsModelData;

  return (
    <div className="modal show d-block" style={{ backgroundColor: "rgba(0, 0, 0, 0.5)" }}>
  <div className="modal-dialog modal-lg modal-dialog-scrollable">
    <div className="modal-content">
      <div className="modal-header">
        <h5 className="modal-title">Client: {client.first_name} {client.last_name}</h5>
        <button type="button" className="btn-close" onClick={onClose}></button>
      </div>

      <div className="modal-body">
        {/* ✅ Basic Info */}
        <div className="mb-5">
          <h5 className="border-bottom pb-2 mb-4 text-primary">Basic Information</h5>
          <div className="row align-items-start">
            {/* Image */}
            <div className="col-md-4 text-center mb-3 mb-md-0">
              <img
                src={`${process.env.REACT_APP_PROFILE_IMAGE_BACKEND_URL}/${client.profile_image}`}
                alt="Client"
                className="rounded shadow"
                style={{ width: "100%", maxWidth: "200px", height: "auto" }}
                onError={(e) => {
                  e.target.onerror = null;
                  e.target.src = `${process.env.REACT_APP_PROFILE_IMAGE_BACKEND_URL}/default.png`;
                }}
              />
            </div>

            {/* Details */}
            <div className="col-md-8">
              <div className="row">
                <div className="col-6">
                  <p><strong>First Name:</strong> {client.first_name}</p>
                  <p><strong>Last Name:</strong> {client.last_name}</p>
                  <p><strong>Parent Name:</strong> {client.parent_name}</p>
                  <p><strong>Birthdate:</strong> {client.birthdate}</p>
                </div>
                <div className="col-6">
                  <p><strong>Address:</strong> {client.address}</p>
                  <p><strong>Email:</strong> {client.email}</p>
                  <p><strong>Phone:</strong> {client.phone}</p>
                  <p><strong>About:</strong> {client.about}</p>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* ✅ Documents */}
        {Array.isArray(client.clientDocument) && client.clientDocument.length > 0 && (
          <div className="mb-5">
            <h5 className="border-bottom pb-2 mb-3 text-primary">Documents</h5>
            <div className="row g-3">
              {client.clientDocument.map((doc, index) => (
                <div className="col-sm-6 col-md-4" key={index}>
                  <div className="card shadow-sm h-100">
                    <img
                      src={`${process.env.REACT_APP_CLIENT_DOCUMENT_BACKEND_URL}/${doc.file_path}`}
                      alt="Document"
                      className="card-img-top"
                      style={{ height: "150px", objectFit: "cover" }}
                    />
                    <div className="card-body">
                      <p className="card-text"><strong>Type:</strong> {doc.file_type}</p>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        )}

        {/* ✅ Self Assessment */}
        <div className="mb-4">
          <h5 className="border-bottom pb-2 mb-3 text-primary">Self Assessment</h5>
          {Array.isArray(client.clientSelfAssessment) && client.clientSelfAssessment.length > 0 ? (
            client.clientSelfAssessment.map((selfAssessment) => (
              <div key={selfAssessment.id} className="card mb-3 shadow-sm">
                <div className="card-body">
                  <p><strong>Question:</strong> {selfAssessment.clientSelfAssessmentMaster?.question_title}</p>
                  {selfAssessment.answer_text ? (
                    <p><strong>Answer:</strong> {selfAssessment.answer_text}</p>
                  ) : (
                    <>
                      <strong>Choices:</strong>
                      <ul className="mb-0 ps-3">
                        {Array.isArray(selfAssessment.clientAssessmentOption) && selfAssessment.clientAssessmentOption.length > 0 ? (
                          selfAssessment.clientAssessmentOption.map((opt) => (
                            <li key={opt.id}>
                              {opt.clientSelfAssessmentOptionMaster?.option || opt.option}
                            </li>
                          ))
                        ) : (
                          <li>No option selected</li>
                        )}
                      </ul>
                    </>
                  )}
                </div>
              </div>
            ))
          ) : (
            <p>No self-assessment available.</p>
          )}
        </div>
      </div>
    </div>
  </div>
</div>

  );
};

export default ProviderClientDetailsModal;
